import BackToPortal from './BackToPortal'

export default BackToPortal
